module.exports = __webpack_public_path__ + "static/media/logo_transparent.ec540e73.png";